import { create } from "zustand";
import type { PriceValues } from "../domain/priceList";

/**
 * Прайс с сервера. В коде цен нет: пока прайс не загружен или в нём не
 * задана нужная строка, конструктор показывает «стоимость уточняется».
 */
interface PriceState {
  values: PriceValues | null;
  status: "idle" | "loading" | "ready" | "error";
  updatedAt: string | null;
  load: () => Promise<void>;
  /** После сохранения в кабинете — сразу пересчитать смету. */
  setValues: (values: PriceValues, updatedAt: string | null) => void;
}

export const usePriceStore = create<PriceState>((set, get) => ({
  values: null,
  status: "idle",
  updatedAt: null,
  load: async () => {
    if (get().status === "loading") return;
    set({ status: "loading" });
    try {
      const response = await fetch("/api/prices", { cache: "no-store" });
      if (!response.ok) throw new Error(String(response.status));
      const data = (await response.json()) as { values?: PriceValues; updatedAt?: string | null };
      set({ values: data.values ?? {}, updatedAt: data.updatedAt ?? null, status: "ready" });
    } catch {
      set({ status: "error" });
    }
  },
  setValues: (values, updatedAt) => set({ values, updatedAt, status: "ready" })
}));
